export default __webpack_public_path__ + "static/lucky-8121130f4858763e12a1c82afeffb888.png";